import { Pipe, PipeTransform } from '@angular/core';
import linkifyHtml from 'linkify-html';
import * as linkify from 'linkifyjs';

const DEFAULT_OPTIONS: linkify.Opts = { defaultProtocol: 'https', target: '_blank' };

@Pipe({
  name: 'linkify',
  standalone: false,
})
export class LinkifyPipe implements PipeTransform {
  public transform(str?: any): string {
    return typeof str === 'string' && str ? linkifyHtml(str, DEFAULT_OPTIONS) : '';
  }
}
